import { polygonZonesBuilder, PolygonZonesModel } from "shared/models/PolygonZones";
import { httpTrafficLights } from "../http/httpClient";

export const polygonZonesService = () => {
  const getAll = async (
    page: number | null,
    page_size: number | null,
    sort: string | null,
    dir: string | null,
  ): Promise<PolygonZonesModel> => {
    const params = new URLSearchParams();
    if (page !== null) params.append('page', String(page));
    if (page_size !== null) params.append('page_size', String(page_size));
    if (sort !== null) params.append('sort', String(sort));
    if (dir !== null) params.append('sort_dir', String(dir));

    const res = await httpTrafficLights.get(`polygon-zones?${params.toString()}`);

    return {
      ...res,
      page: Number(res.page),
      page_size: Number(res.page_size),
      total: Number(res.total),
      rows: res.rows.map(polygonZonesBuilder.fromBackEnd),
    };
  };

  return {
    getAll,
  };
};

